import React, { Component } from 'react'
import { Box, Button, Text, Flex } from 'rebass'
import styled from 'styled-components'
import { Parallax } from 'react-scroll-parallax'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import Tiltable from '../components/Tiltable'
import LeftArrow from '../images/icons/left-arrow.svg'
import RightArrow from '../images/icons/right-arrow.svg'

const query = graphql`
  query {
    site {
      siteMetadata {
        quotes {
          citation
          body
        }
      }
    }
    guitar: file(relativePath: { eq: "guitar.jpg" }) {
      childImageSharp {
        fixed(width: 213, height: 213) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const GuitarImageWrap = styled(Box)`
  display: none;
  position: absolute;
  left: 3%;
  top: 60%;
  z-index: 10;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: inline-flex;
  }
`

const Quote = styled(Text)`
  font-family: ${props => props.theme.fonts.serif};
  line-height: 1.45;
  font-size: ${props => props.theme.fontSizes[3]}px;
  font-weight: normal;
`
const Citation = styled(Text)`
  text-transform: uppercase;
  letter-spacing: 1.46px;
  margin-top: ${props => props.theme.space[5]}px;
`

const SliderButton = styled(Button)`
  background: transparent;
  color: ${props => props.theme.colors.black};
  border-radius: 100%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: 0;
  }

  &:hover {
    opacity: 0.4;
  }
`

const MobileButtonWrap = styled(Flex)`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.space[3]}px;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: none;
  }
`

const ButtonWrap = styled(Box)`
  display: none;
  position: absolute;
  height: 100%;
  top: 0;
  align-items: center;
  z-index: 20;
  ${props => props.side}: 0;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: flex;
  }
`

class Quotes extends Component {
  constructor() {
    super()
    this.sliderRef = React.createRef()
  }

  state = {
    slider: null,
  }

  componentDidMount() {
    const Flickity = require('flickity')
    const slider = new Flickity(this.sliderRef.current, {
      autoPlay: 5000,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
    })
    setTimeout(() => {
      slider.resize()
    }, 0)
    this.setState({ slider })
  }

  handlePrevious = () => {
    this.state.slider.previous()
  }

  handleNext = () => {
    this.state.slider.next()
  }

  render() {
    return (
      <StaticQuery
        query={query}
        render={data => (
          <Box css={{ position: 'relative' }}>
            <GuitarImageWrap>
              <Parallax y={[-20, 30]}>
                <Tiltable>
                  <Img
                    style={{
                      transform: 'rotate(-5deg)',
                      boxShadow: '0 4px 15px 0 rgba(0,0,0,0.50)',
                    }}
                    fixed={data.guitar.childImageSharp.fixed}
                  />
                </Tiltable>
              </Parallax>
            </GuitarImageWrap>
            <Box
              px={[0, 48]}
              css={{ maxWidth: 800, textAlign: 'center', position: 'relative' }}
              mx="auto"
            >
              <ButtonWrap side="left">
                <SliderButton onClick={this.handlePrevious}>
                  <LeftArrow />
                </SliderButton>
              </ButtonWrap>
              <Box ref={this.sliderRef}>
                {data.site.siteMetadata.quotes.map((q, i) => (
                  <Box width={1} key={i}>
                    <Quote>
                      &ldquo;
                      <span dangerouslySetInnerHTML={{ __html: q.body }} />
                      &rdquo;
                    </Quote>
                    <Citation
                      dangerouslySetInnerHTML={{ __html: q.citation }}
                    />
                  </Box>
                ))}
              </Box>
              <ButtonWrap side="right">
                <SliderButton onClick={this.handleNext}>
                  <RightArrow />
                </SliderButton>
              </ButtonWrap>
            </Box>
            <MobileButtonWrap>
              <SliderButton onClick={this.handlePrevious}>
                <LeftArrow />
              </SliderButton>
              <SliderButton onClick={this.handleNext}>
                <RightArrow />
              </SliderButton>
            </MobileButtonWrap>
          </Box>
        )}
      />
    )
  }
}
export default Quotes
